import { AccessCards, Wedding } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const updateAccessCards = generateAPI<
  {
    body: {
      accessCards: AccessCards;
    };
  },
  Wedding
>("put", "wedding/access-cards", "wedding/");
